import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
  Box,
  Grid,

} from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import StockCard from 'components/ui/StockCard';
import { SettingContext } from "context/SettingContext";
import { useGlobalContext } from 'context/GlobalContext';
// import { useMeltingRequestDetail } from '../API/meltingrequestapi';


import useStockInCatalog from 'hooks/useStockInCatalog';
import { useDispatch, useSelector } from 'react-redux';
import { addEditCategory, initEditCategory, removeEditCategory } from 'store/cartSlice';


const MeltingRequestProduct = ({ product }) => {
  // const { meltingRequestId } = useParams();
  // console.log("id ahe",id);

  const navigate = useNavigate();
  const location = useLocation();
  
  const { requestData } = location.state || {};

  // const [selectedProductIds, setSelectedProductIds] = useState([]);
  const { setSearchBar, search } = useContext(SettingContext);
  const { setSearchPlaceHolder } = useGlobalContext();

  const dispatch = useDispatch();




  const mode = location.state?.mode;

  // const { data: meltingDesignData, isLoading, isError, error } = useMeltingRequestDetail(meltingRequestId);
  // console.log("datatatat",id);

  // const data = meltingDesignData?.data;

  const { setBtnTitle, btnTitle } = useStockInCatalog(product, "", "removeMeltingDesign");

  const selectedCartProducts = useMemo(
    () => ({
      ...product,
      isAddedInCart: true,
    }),
    [product]
  );


  // data should now be the array from res.data.result.data
  // console.log("Products data:", data);

  // const handleSelectProduct = (product) => {
  //     let newSelectedIds;

  //     if (selectedProductIds.includes(product.jewelId || product._id)) {
  //         newSelectedIds = selectedProductIds.filter(id => id !== (product.jewelId || product._id));
  //     } else {
  //         newSelectedIds = [...selectedProductIds, (product.jewelId || product._id)];
  //     }

  //     setSelectedProductIds(newSelectedIds);

  //     const selectedProducts = Array.isArray(data) 
  //         ? data.filter(p => newSelectedIds.includes(p.jewelId || p._id)) 
  //         : [];
  //     updateMeltingSelections(selectedProducts);
  // };

  const handleSelectProduct = () => {
    dispatch(
      addEditCategory({
        storageKey: "removeMeltingDesign",
        data: {
          _id: product?._id || product?.id,
          styleNumber: product?.styleNumber,
          jewelCode: product?.jewelCode,
        },
      })
    );
    setBtnTitle("Selected");
  };




  const handleRemoveProduct = () => {
    setBtnTitle("Select");

    dispatch(
      removeEditCategory({
        storageKey: "removeMeltingDesign",
        id: product?.id || product?._id,
        
      })
    );
  }

  const isSelectedForEdit = useSelector((state) =>
    state.editCategory.data.some(
      (item) => item.styleNumber === product.styleNumber
    )
  );


  useEffect(() => {
    if (isSelectedForEdit) {
      setBtnTitle("Selected");
    } else {
      setBtnTitle("Select");
    }
    return;
  }, [isSelectedForEdit, setBtnTitle]);

  useEffect(() => {
    dispatch(initEditCategory("removeMeltingDesign"));
  }, [dispatch]);


  // const getSelectedCartProducts = () => {
  //     return Array.isArray(data) 
  //         ? data.filter(product => selectedProductIds.includes(product.jewelId || product._id)) 
  //         : [];
  // };

  // useEffect(() => {
  //     const selectedProducts = Array.isArray(data) 
  //         ? data.filter(p => selectedProductIds.includes(p.jewelId || p._id)) 
  //         : [];
  //     updateMeltingSelections(selectedProducts);
  // }, [selectedProductIds, data]);

  useEffect(() => {
    setSearchBar(true);
    setSearchPlaceHolder("Search By Jewel Code or Design Number");
  }, [])

  // useEffect(() => {
  //     if (!Array.isArray(data)) return;

  //     if (search === "") {
  //         setDynamicFilterCount(true);
  //     }
  //     if (dynamicfilterCount) {
  //         setFilterChangeCount(data.length);
  //         setSearchResultCount(data.length);
  //     } else {
  //         setSearchResultCount(data.length);
  //         setFilterChangeCount(filterChangeCount);
  //     }
  //     setDisplayCount(true);
  //     setMeltingStatus(meltingDesignData?.statusTimeline)
  //     return () => {
  //         setSearchResultCount(0);
  //         setFilterChangeCount(0);
  //         setMeltingStatus("");
  //         setDisplayCount(false);
  //     };
  // }, [meltingDesignData]);

  // if (isLoading) return <ProductSkeleton count={10} />;
  // if (isError) return <p>Error loading details</p>;
  // if (!Array.isArray(data) || data.length === 0) return <p>No products found</p>;

  return (
    <Grid item className="stock" >
      <StockCard
        data={product}
        selectedCartProducts={selectedCartProducts}
        isBtn={mode === "remove"}
        addtoCart={handleSelectProduct}
        removeCart={handleRemoveProduct}
        btnTilte={btnTitle}

      />
    </Grid>
  );
};

export default React.memo(MeltingRequestProduct);